webpackJsonp([23],{

/***/ 1019:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_login_js__ = __webpack_require__(1086);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa0b17e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__(1171);
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_login_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa0b17e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1053:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  uploadImage: function uploadImage(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'upload/v1/upload/image', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  isLogin: function isLogin(URL, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/signin', body).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addUser: function addUser(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/add/user', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  listUser: function listUser(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/list/user', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  removeUser: function removeUser(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/remove/user/code', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getRole: function getRole(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/list/role', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  userDetail: function userDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/get/user/code', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  userUpdate: function userUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/update/user/code', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  configDetail: function configDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/branch/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  confighUpdate: function confighUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/branch/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShift: function getHostShift(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'company/v1/host/list', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  companyDetail: function companyDetail(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'company/v1/list', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  companyUpdate: function companyUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  hostUpdate: function hostUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/host/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6672276.2a14d13.jpg";

/***/ }),

/***/ 1086:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1053);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: '',
      password: '',
      check_con: '',
      secon_timer: 0,
      header: {
        headers: {
          'Access-Token': ''
        }
      }
    };
  },

  methods: {
    sigin: function sigin() {
      var _this = this;

      this.$store.commit('Loading');
      var body = {
        'username': this.username,
        'password': this.password
      };
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].isLogin(this.REST_URL, body, function (result) {
        if (result.response === 'success') {
          sessionStorage.token = result.data.token;
          _this.$store.state.token = result.data.token;
          _this.getProfile();
        } else {
          _this.$notification['warning']({
            message: 'เข้าสู่ระบบ',
            description: result.message
          });
          _this.$store.commit('Loading');
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    getProfile: function getProfile() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].userDetail(this.REST_URL, {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }, {}, function (result) {
        if (result.response === 'success') {
          sessionStorage.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
          _this2.$store.state.user = result.data;
          localStorage.setItem('user', sessionStorage.user);
          _this2.$notification['success']({
            message: 'เข้าสู่ระบบ',
            description: 'ยินดีตอนรับคุณ ' + _this2.username + ' เข้าสู่ระบบ'
          });
          _this2.autoGoToPOS();
        } else {
          _this2.$notification['warning']({
            message: 'เข้าสู่ระบบ',
            description: result.message
          });
        }
        _this2.$store.commit('Loading');
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this2.$store.commit('Loading');
      });
    },
    autoGoToPOS: function autoGoToPOS() {
      var _this3 = this;

      this.header.headers['Access-Token'] = sessionStorage.token;
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].getHostShift(this.REST_URL, { headers: { 'Access-Token': sessionStorage.token } }, function (result) {
        if (result.response === 'success' && result.data && result.data.length > 0) {
          _this3.getListHostDetail(result.data[0]);
        } else {
          _this3.$router.push('/');
        }
      }, function (_error) {
        _this3.$router.push('/');
      });
    },
    checkConnect: function checkConnect() {
      var _this4 = this;

      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].userDetail(this.REST_URL, {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }, {}, function (result) {
        if (result.response) {
          _this4.$store.state.isLoading = false;
          clearInterval(_this4.check_con);
          console.log('use time' + _this4.secon_timer);
        }
      },
      // eslint-disable-next-line handle-callback-err
      function (error) {
        console.log(error.message);
        if (error.message === 'Request failed with status code 404' || error.message === 'Network Error') {
          console.log('connect error');
          setTimeout(function () {
            _this4.checkConnect();
          }, 3000);
        } else {
          _this4.$store.state.isLoading = false;
          clearInterval(_this4.check_con);
          console.log('use time' + _this4.secon_timer);
        }
      });
    }
  },
  mounted: function mounted() {
    this.$store.commit('clearState');
    this.checkConnect();
    // this.check_con = setInterval(() => {
    //   this.checkConnect()
    //   this.secon_timer += 3
    // }, 3000)
  }
});

/***/ }),

/***/ 1171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",style:({
    height: _vm.$store.state.screenHeight - 90 + 'px'
  })},[_c('div',{staticClass:"card",staticStyle:{"width":"320px"}},[_c('div',{staticClass:"card-body text-center"},[_c('img',{attrs:{"src":__webpack_require__(1071),"width":"100"}}),_vm._v(" "),_c('form',{staticClass:"text-left mt-3",on:{"submit":function($event){$event.preventDefault();return _vm.sigin.apply(null, arguments)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"exampleInputUser"}},[_vm._v("Username")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control",attrs:{"type":"text","id":"exampleInputUser","placeholder":"Username...","autocomplete":"username","required":""},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"exampleInputPassword"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","id":"exampleInputPassword","placeholder":"Password...","autocomplete":"new-password","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger btn-block btn-lg",attrs:{"type":"submit"}},[_c('i',{staticClass:"fas fa-sign-in-alt"}),_vm._v(" เข้าสู่ระบบ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/23.fc650aa75f545af18706.js